<template>
	<nav class="navbar navbar-expand-md navbar-light fixed-top bg-white">
		<div class="container-fluid px-lg-5 px-xl-5">
			<a
				class="navbar-brand cursor-pointer"
				@click.stop="$router.push({ name: 'Home' })"
				><img id="logo" src="../assets/logo.png" alt="logo"
			/></a>
			<button
				class="navbar-toggler"
				type="button"
				data-bs-toggle="collapse"
				data-bs-target="#navbarCollapse"
				aria-controls="navbarCollapse"
				aria-expanded="false"
				aria-label="Toggle navigation"
			>
				<span class="navbar-toggler-icon"></span>
			</button>
			<div
				class="collapse navbar-collapse bg-light justify-content-between"
				id="navbarCollapse"
			>
				<ul class="navbar-nav mb-2 mb-md-0">
					<li class="nav-item">
						<a
							class="nav-link cursor-pointer"
							aria-current="page"
							@click.stop="changeActiveNav, $router.push({ name: 'Dashboard' })"
							>Dashboard</a
						>
					</li>
					<li class="nav-item">
						<a
							class="nav-link active cursor-pointer"
							aria-current="page"
							@click.stop="$router.push({ name: 'Leads' }), changeActiveNav"
							>Leads</a
						>
					</li>
					<li
						v-if="
							store.state?.user?.role &&
							store.state?.user?.role[0] !== roles?.env_se
						"
						class="nav-item"
					>
						<a
							class="nav-link active cursor-pointer"
							aria-current="page"
							@click.stop="$router.push({ name: 'Customers' }), changeActiveNav"
							>Customers</a
						>
					</li>
					<li
						v-if="
							store.state?.user?.role &&
							store.state.user.role[0] === roles.env_admin
						"
						class="nav-item dropdown"
					>
						<a
							class="nav-link dropdown-toggle cursor-pointer"
							id="navbarScrollingDropdown"
							role="button"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							Masters
						</a>
						<ul class="dropdown-menu" aria-labelledby="navbarScrollingDropdown">
							<a
								class="dropdown-item cursor-pointer"
								@click.stop="
									$router.push({ name: 'Announcement' }), changeActiveNav
								"
								>Announcement</a
							>
							<a
								class="dropdown-item cursor-pointer"
								@click.stop="$router.push({ name: 'Hotel' }), changeActiveNav"
								>Hotels</a
							>
							<a
								class="dropdown-item cursor-pointer"
								@click.stop="
									$router.push({ name: 'Packages' }), changeActiveNav
								"
								>Packages</a
							>
							<a
								class="dropdown-item cursor-pointer"
								@click.stop="
									$router.push({ name: 'Sightseeing' }), changeActiveNav
								"
								>Sightseeing</a
							>
							<a
								class="dropdown-item cursor-pointer"
								@click.stop="$router.push({ name: 'Tags' }), changeActiveNav"
								>Tags</a
							>
							<a
								class="dropdown-item cursor-pointer"
								@click.stop="
									$router.push({ name: 'Transports' }), changeActiveNav
								"
								>Transports</a
							>
							<a
								v-if="
									store.state?.user?.role &&
									store.state?.user?.role[0] === roles.env_admin
								"
								class="dropdown-item cursor-pointer"
								@click.stop="$router.push({ name: 'Users' }), changeActiveNav"
								>Users</a
							>
							<a
								class="dropdown-item cursor-pointer"
								@click.stop="
									$router.push({ name: 'Vehicles' }), changeActiveNav
								"
								>Vehicles</a
							>
						</ul>
					</li>
				</ul>

				<div class="row">
					<div
						class="d-flex dropdown col-2 justify-content-start align-items-center"
					>
						<a
							class="d-block link-dark text-decoration-none text-white lg d-flex justify-content-center align-items-center cursor-pointer position-relative"
							id="dropdownNotification"
							data-bs-toggle="dropdown"
							aria-expanded="true"
						>
							<i class="bi bi-bell text-dark fs-4"> </i>
							<span
								class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer text-dark"
								>{{ notifications.state.count }}</span
							>
						</a>
						<ul
							class="dropdown-menu px-2 notification"
							aria-labelledby="dropdownNotification"
							data-popper-placement="bottom-start"
							style="position: absolute; left: 0; top: 100%; width: 200px"
						>
							<li
								v-if="notifications.state.notification_general.length"
								class=""
							>
								<span class="fs-4 mt-2">General Notifications</span>
								<div
									v-for="notificationData in notifications.state
										.notification_general"
									:key="notificationData.id"
									class="general mt-1 p-2 border border-success text-success"
								>
									{{ notificationData.text }}
								</div>
							</li>
							<li
								v-if="notifications.state.notification_success.length"
								class=""
							>
								<div
									v-for="notificationData in notifications.state
										.notification_success"
									:key="notificationData.id"
									class="success mt-1 p-2 border border-success text-success"
								>
									{{ notificationData.text }}
								</div>
							</li>
							<li v-if="notifications.state.notification_role.length" class="">
								<div
									v-for="notificationData in notifications.state
										.notification_role"
									:key="notificationData.id"
									class="role mt-1 p-2 border border-success text-success"
								>
									{{ notificationData.text }}
								</div>
							</li>
							<li v-if="notifications.state.notification_me.length" class="">
								<div
									v-for="notificationData in notifications.state
										.notification_me"
									:key="notificationData.id"
									class="role mt-1 p-2 border border-success text-success"
								>
									{{ notificationData.text }}
								</div>
							</li>
							<li
								v-if="notifications.state.notification_warnings.length"
								class=""
							>
								<span class="fs-4 mt-2">Warnings</span>
								<div
									v-for="notificationData in notifications.state
										.notification_warnings"
									:key="notificationData.id"
									class="role mt-1 p-2 border border-warning text-warning"
								>
									{{ notificationData.text }}
								</div>
							</li>
							<li
								v-if="notifications.state.notification_errors.length"
								class=""
							>
								<span class="fs-4 mt-2">Errors</span>
								<div
									v-for="notificationData in notifications.state
										.notification_errors"
									:key="notificationData.id"
									class="role mt-1 p-2 border border-danger text-danger"
								>
									{{ notificationData.text }}
								</div>
							</li>
						</ul>
					</div>
					<div class="d-flex col-7 justify-content-end align-items-center">
						<a
							class="d-block link-dark text-decoration-none text-white cursor-pointer"
							id="dropdownUser1"
							@click.stop="$router.push({ name: 'Profile' }), changeActiveNav"
						>
							<img
								:src="store.state.user.image"
								alt="profile"
								width="42"
								height="42"
								class="rounded-circle"
							/>
							&nbsp;&nbsp;<span class="fs-6 text-dark">{{
								store.state.user.name
							}}</span>
						</a>
					</div>
					<div class="col-3">
						<button
							class="btn btn-sm bg-danger text-dark rounded"
							type="button"
							@click.stop="logout"
						>
							Log out <i class="bi bi-box-arrow-right"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
	import { inject, reactive } from "vue";
	import { useRouter } from "vue-router";
	import API from "@/config/api";
	import toast from "@/config/toast";

	export default {
		name: "TheHeader",
		setup: () => {
			const store = inject("store");
			const notifications = inject("notifications");

			const roles = reactive({
				env_admin: process.env.VUE_APP_USER_ADMIN,
				env_se: process.env.VUE_APP_USER_SERVICE_EXECUTIVE,
			});

			const userImage = reactive({
				url: process.env.VUE_APP_IMAGE_PREFIX,
			});

			const router = useRouter();

			const getNotification = async () => {
				try {
					const list = await API.privateRequest.get("notifications");
					let data = {
						notification_success: [],
						notification_errors: [],
						notification_warnings: [],
						notification_role: [],
						notification_me: [],
						notification_general: [],
					};

					list.data.data.map((notification) => {
						if (notification.type === "success")
							data.notification_success.push(notification);
						else if (notification.type === "error")
							data.notification_errors.push(notification);
						else if (notification.type === "warning")
							data.notification_warnings.push(notification);
						else if (notification.type === "role")
							data.notification_role.push(notification);
						else if (notification.type === "me")
							data.notification_me.push(notification);
						else data.notification_general.push(notification);
					});

					Object.keys(data).map(
						(key) => (notifications.state[key] = [...data[key]]),
					);
					notifications.methods.setCount();
				} catch (error) {
					console.log("unable  to get notification");
					console.log(error);
				}
			};

			const logout = async () => {
				try {
					await API.generalRequest.get(`auth/logout/${store.state.user.id}`);
					toast.success(
						{ message: "logged out !", position: "topRight" },
						true,
					);
				} catch (error) {
					toast.error("Unable to logout", true);
				}
				store.methods.removeState();
				router.push({ name: "Login" });
			};

			const changeActiveNav = (event) => {
				event.srcElement.parentElement.parentElement.childNodes.forEach((v) => {
					v.childNodes[0].classList.remove("active");
				});
				event.srcElement.classList.add("active");
			};

			getNotification();

			return {
				store,
				notifications,
				roles,
				userImage,
				logout,
				changeActiveNav,
			};
		},
	};
</script>
<style scoped>
	#logo {
		height: 55px !important;
	}
	@media only screen and (min-width: 768px) {
		.dropdown:hover .dropdown-menu {
			display: block;
		}
	}
	.fixed-top {
		height: 65px;
		box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px;
	}
	.notification {
		width: 300px !important;
		height: 300px;
		overflow-y: auto;
	}
	.notification li > div {
		border-radius: 8px !important;
		overflow: hidden;
	}
</style>